import { RouteObject } from 'react-router-dom';
import { RootLayout } from 'app/components/layouts/RootLayout';

import LiveChat from './screens/LiveChat';
import Tooltip from './screens/Tooltip';

const liveChatRoutes: RouteObject[] = [
  {
    path: '/live-chat',
    element: <RootLayout />,
    children: [
      {
        path: '/live-chat',
        element: <LiveChat />,
      },
    ],
  },
  {
    path: '/live-chat',
    element: <RootLayout hideImportantInformation />,
    children: [
      {
        path: 'tooltip',
        element: <Tooltip />,
      },
    ],
  },
];

export default liveChatRoutes;
